<script lang="ts">
    import { _ } from 'svelte-i18n';

    import type { RoutePointExtendedType } from '../../../utilities/RoutePointsApi';
    import { TimeWindow, type TimeWindowType } from '../TimeWindow';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import SuccessColor from '../../../shared/SuccessColor.svelte';
    import ErrorColor from '../../../shared/ErrorColor.svelte';
    import { type ReorderedRouteType } from '../AssignmentApi';
    import Duration from '../../../shared/Duration.svelte';
    import Dummy from '../../../shared/Dummy.svelte';
    import type { Assignment } from '../Assignment';
    import { ResolutionTime } from '../../telematics/components/Colorizer/ResolutionTime';
    import { RoutePointCalc } from './RoutePointCalc';

    export let routePoint: RoutePointExtendedType;
    export let routeDirty: boolean;
    export let assignment: Assignment;
    export let modifiedRouteData: ReorderedRouteType | null = null;
    export let timeWindow: TimeWindow | null = null;

    let eta: number | null = null;
    let approached: number | null = null;
    let delay: number | null = null;
    let timeStyleComponent = Dummy;

    let timeWindows: Record<string, TimeWindowType> = {};
    let timeWindowsGroups: Record<string, number> = {};

    $: {
        if (routePoint.jobs) {
            try {
                timeWindows = {};
                timeWindowsGroups = {};
                let alerts = modifiedRouteData
                    ? modifiedRouteData.alerts?.time_window
                    : assignment.getRouteInfo()?.alerts?.time_window;
                if (alerts) {
                    for (let jobId of routePoint.jobs) {
                        if (alerts[jobId]) {
                            let timeWindow = new TimeWindow(alerts[jobId]);
                            if (timeWindow.isValid()) {
                                timeWindows[jobId] = alerts[jobId];
                                if (timeWindow.isFulfilled()) {
                                    timeWindowsGroups.fullfilled =
                                        (timeWindowsGroups.fullfilled || 0) + 1;
                                } else if (timeWindow.isAboveThreshold()) {
                                    timeWindowsGroups.error = (timeWindowsGroups.error || 0) + 1;
                                } else {
                                    timeWindowsGroups.warning =
                                        (timeWindowsGroups.warning || 0) + 1;
                                }
                            }
                        }
                    }
                }
                eta = RoutePointCalc.getEta(modifiedRouteData, routePoint, assignment);
                let delta = RoutePointCalc.getDelta(modifiedRouteData, routePoint);
                // console.log('RoutePointEta, eta,delta', eta, delta, modifiedRouteData, routePoint);

                approached = null;
                delay = null;
                if (routePoint?.realisation?.approached) {
                    approached =
                        (Math.round(routePoint?.realisation?.approached / 60) % (24 * 60)) -
                        new Date().getTimezoneOffset();
                }
                timeStyleComponent = Dummy;
                if (approached !== null && eta !== null && delta !== null) {
                    let etaTimestamp =
                        Math.floor(
                            Date.parse(assignment.getStartDateRoute().replace(' ', 'T')) / 1000
                        ) +
                        delta.g.t * 60;
                    delay = Math.round((routePoint?.realisation?.approached - etaTimestamp) / 60);
                    if (delay > 0) {
                        timeStyleComponent = delay > 10 ? ErrorColor : WarningColor;
                    } else {
                        timeStyleComponent = SuccessColor;
                    }
                }
                timeStyleComponent = Dummy; // FIXME: remove this line if color should be displayed
            } catch (e) {
                console.error(e);
            }
        }
    }

    $: {
        if (timeWindow) {
            timeStyleComponent = timeWindow.getColorComponentGlobal();
        }
    }

    let delta2: any = {};
    let etaTimestamp2: number | null = null;
    let targetTime: string = '';

    $: {
        try {
            delta2 = modifiedRouteData?.deltas[routePoint.point_order] || routePoint.delta;
            if (delta2) {
                etaTimestamp2 =
                    Math.floor(Date.parse(assignment.getStartDateRoute().replace(' ', 'T')) / 1000) +
                    delta2.g.t * 60;
                if (typeof etaTimestamp2 === 'number') {
                    targetTime = ResolutionTime.getDateStringFromMinutes(
                        etaTimestamp2 / 60 - new Date().getTimezoneOffset()
                    );
                }
            } else {
                targetTime = '--:--';
            }
        } catch (e) {
            console.error(e);
            targetTime = '--:--';
        }
    }
</script>

<div
    class="eta"
    class:approached={routePoint?.realisation?.approached}
    data-eta={eta}
    data-approached={approached}
    data-routePoint-jobs={routePoint.jobs}
    data-routeDirty={routeDirty}
>
    <svelte:component this={timeStyleComponent}>
        {#if !routeDirty && routePoint.jobs && (eta !== null || approached !== null)}
            <Duration
                seconds={(approached !== null ? approached : eta || 0) * 60}
                warningAbove={null}
                displayFormat="time"
                title={delay !== null
                    ? delay === 0
                        ? $_('route_realisation_on_time', {
                              values: { target: targetTime },
                          })
                        : delay < 0
                          ? $_('route_realisation_before_time', {
                                values: {
                                    diff: Math.abs(delay),
                                    target: targetTime,
                                },
                            })
                          : $_('route_realisation_delay', {
                                values: { diff: delay, target: targetTime },
                            })
                    : ''}
            />
        {/if}
    </svelte:component>
</div>

<style>
    .eta {
        display: flex;
        width: 100%;
        justify-content: flex-end;
    }
</style>
